var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.item.text,"maxlength":"19","value":_vm.displayValue,"disabled":!_vm.editable,"hint":"Napr. 31.12.2020 16:40:00","clearable":""},on:{"blur":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }